/**
 * 财务会计侧栏（Overseas patch 211）
 */
export const FINANCE_ACCOUNTING_MENU_IDS = {
  group: 990160,
  reports: 990161,
  view: 990162
}

export default FINANCE_ACCOUNTING_MENU_IDS



// WEBPACK FOOTER //
// ./src/constants/financeAccounting.js